import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export function getAxisHighlightUtilityClass(slot) {
  return generateUtilityClass('MuiChartsAxisHighlight', slot);
}
export const chartsAxisHighlightClasses = generateUtilityClasses('MuiChartsAxisHighlight', ['root']);